export default "__VITE_ASSET__Muvp1Ufk__"